import React from 'react';
import FancyTitle from '../fancy-title';

export default function ProvenexpertForm({ blok }) {
  const { title } = blok;
  return (
    <div className="pb-[70px] px-8 lg:px-20 -mt-12">
      <FancyTitle
        text={title}
        textAlign="text-center lg:text-center"
        className="mx-auto"
        marginBottom="mb-10"
        tag="h2"
        fontSize="text-2xl lg:text-4xl"
      />
      <div className="flex justify-center">
        <a
          href="https://www.provenexpert.com/latori-gmbh/?utm_source=Widget&amp;utm_medium=Widget&amp;utm_campaign=Widget"
          title="Kundenbewertungen &amp; Erfahrungen zu Latori GmbH. Mehr Infos anzeigen."
          target="_blank"
          style={{ textDecoration: 'none' }}
          rel="noopener noreferrer"
        >
          <img
            src="https://images.provenexpert.com/40/6b/b6696f08357269dd54269cfdb1c2/widget_landscape_165_de_0.png"
            alt="Erfahrungen &amp; Bewertungen zu Latori GmbH"
            width="165"
            height="138"
            style={{ border: 0 }}
            loading="lazy"
            decoding="async"
          />
        </a>
      </div>

    </div>
  );
}
